import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form,Tooltip, Button, Spinner, Alert, Card } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { newSubProductCreation,getAllMainSubProduct } from "./subproductAction";
import { newAdultRatesCreation,newHourRatesCreation,newVehicleRatesCreation,newChildRatesCreation,newInfantRatesCreation,newSeasonalRatesCreation ,newPromotionRatesCreation,getSingleProductRate} from "../rates/ratesAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import Datetime from "react-datetime";
import { DefaultEditor } from 'react-simple-wysiwyg';
import { upload } from '@testing-library/user-event/dist/upload';
import UploadService from "../../../api/FileUploadApi";
import { useNavigate,useParams, Link } from 'react-router-dom';
import Swal from 'sweetalert2'
import { getAllProduct } from "../product/productAction";
import { FaEye, FaArrowLeft, FaArrowAltCircleRight, FaTrash, FaPlus, FaBan} from 'react-icons/fa';
// import { Tooltip } from 'react-tooltip';
import { getSinglePaxhealth } from "../paxhealth/paxhealthAction";


const CreateSubProduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { SubProductId } = useParams();
  const { name } = useParams();
  const { pname } = useParams();
  const { pid } = useParams();
  const SubProductRef = useRef(null);
  const [productid,setProductid]= useState('');
  const [subproductname,setSubproductname]= useState('');
  
  const [perShow,setPerShow] = useState(false);
  const [fixamtShow,setFixamtShow] = useState(false);

  const [percentage,setPercentage]= useState('');
  const [fixamt,setFixamt]= useState('');
  const [paxlimit,setPaxlimit]= useState('');
  const [paxlimitno,setPaxlimitNo]= useState('');
  const [dateRangeExists, setDateRangeExists] = useState(false);


  const [status,setStatus]= useState('');
  const [sfromDate , setSFromDate ] = useState('');
  const [toDate2 , setToDate2 ] = useState('');
  const [discounttype , setDiscounttype ] = useState('');
  const [discounttype2 , setDiscounttype2 ] = useState('');
  const [discount2 , setDiscount2 ] = useState('');
  const [hourrate, setHourrate] = useState([]);
  const [vehiclerate, setVehiclerate] = useState([]);
  const [discount , setDiscount ] = useState('');
  const [seasonalremark , setSeasonalremark ] = useState('');
  const [promotionremark , setPromotionremark ] = useState('');
  const [offercode , setOffercode ] = useState('');
  const [toDate3 , setToDate3 ] = useState('');
  const [fromDate , setFromDate ] = useState('');
  const [toDate , setToDate ] = useState('');
  const [fromDate2 , setFromDate2 ] = useState('');
  const [fromAge2, setFromAge2] = useState('');
  const [fromAge, setFromAge] = useState('');
  const [toAge, setToAge] = useState('');
  const [toAge2, setToAge2] = useState('');
  const [errors2, setErrors2] = useState({});
  const [tabHandle, setTabHandle] = useState('adultrate');
  const [tabHandle2, setTabHandle2] = useState('rate');
  const [errors3, setErrors3] = useState({});
  const [fromAgeError, setFromAgeError] = useState('');
  const [toAgeError, setToAgeError] = useState('');

  const [fromDateError, setFromDateError] = useState('');
  const [fromDateError2, setFromDateError2] = useState('');
  const [toDateError, setToDateError] = useState('');
  const [toDateError2, setToDateError2] = useState('');
  const [permdata , setPermdata] = useState();
   
  console.log("permdata",permdata)
   

  const [paxlimitshow, setPaxlimitShow] = useState(false);
  const { subproducts2 } = useSelector((state) => state.subproductList);



  const [fromAgeError2, setFromAgeError2] = useState('');
  const [toAgeError2, setToAgeError2] = useState('');
  const paxData = useSelector((state) => state.paxList);
  const pxData = JSON.parse(JSON.stringify(paxData.pSDetails));

  const [alertStatus, setAlertStatus] = useState('');
  const { register, handleSubmit, watch,formState: { errors } ,trigger} = useForm();
  const { products } = useSelector((state) => state.productList);
  const { baseid ,rates } = useSelector((state) => state.productratesList);
  console.log("ratess",rates)
//   const { SubProductId } = useSelector((state) => state.subproductList);
// console.log("SubProductId",SubProductId)
  const { supiscLoading, supcstatus, supcMessage, } = useSelector((state) => state.supplierList);
  const [sections, setSections] = useState([]);
  const [sections2, setSections2] = useState([]);
  console.log("helllllo2",sections2.length)

  const [sections3, setSections3] = useState([]);
  const [sections4, setSections4] = useState([]);
  const [adultrate, setAdultrate] = useState([]);
  const [extraAdultrate, setExtraAdultrate] = useState([]);
  const [childrate, setChildrate] = useState([]);
  const [infantrate, setInfantrate] = useState([]);
  const [datedisable, setDatedisable] = useState(true);
  const [seasonal, setSeasonal] = useState([]);
  const [promotion, setPromotion] = useState([]);
  const [isToDateSelected, setIsToDateSelected] = useState(false);


  const [toDateErrorRate, setToDateErrorRate] = useState('');


  const adultrates  = useSelector((state) => state.productratesList?.rates?.baseList || {});
  console.log("naam ",adultrates)

  
  const handleAddSection = () => {
    setSections(prevSections => [...prevSections, { childrate: Array(7).fill('') }]);
  };
  const handleAddSection2 = () => {
    setSections2(prevSections => [...prevSections, { infantrate: Array(7).fill('') }]);
  };


  const handleAddSection3 = () => {
    setSections3(prevSections => [...prevSections, { seasonal: Array(7).fill('') }]);
  };

  const handleAddSection4 = () => {
    setSections4(prevSections => [...prevSections, { promotion: Array(7).fill('') }]);
  };

  const handleRemoveSection = (index) => {
    setSections(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleRemoveSection2 = (index) => {
    setSections2(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleRemoveSection3 = (index) => {
    setSections3(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleRemoveSection4 = (index) => {
    setSections4(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleCopyToAll2 = (sectionIndex, index) => {
    const selectedValue = sections[sectionIndex].childrate[index];
  const updatedRates = sections[sectionIndex].childrate.map(() => selectedValue);

  const updatedSections = [...sections];
  updatedSections[sectionIndex].childrate = updatedRates;
  setSections(updatedSections);
  };

  useEffect(() => {
    const checkIfExists = () => {
      if (fromDate && toDate) {
        const exists = adultrates.some(
          (item) => item.from_date <= toDate && item.to_date >= fromDate && item.product == SubProductId
        );
        setDateRangeExists(exists);
        if (exists) {
          setToDate('');
        }
      
      }
    };
  
    checkIfExists();
  }, [fromDate, toDate, adultrates]);
  


  const handleCopyToAll3 = (sectionIndex, index) => {
    const selectedValue = sections2[sectionIndex].infantrate[index];
  const updatedRates = sections2[sectionIndex].infantrate.map(() => selectedValue);

  const updatedSections = [...sections2];
  updatedSections[sectionIndex].infantrate = updatedRates;
  setSections2(updatedSections);
  };

  const handleChildRateChange = (sectionIndex, index, value) => {
    const updatedSections = [...sections];
    updatedSections[sectionIndex].childrate[index] = value;
    setSections(updatedSections);
    setChildrate(updatedSections)
  };


  const handleInfantRateChange = (sectionIndex, index, value) => {
    const updatedSections = [...sections2];
    updatedSections[sectionIndex].infantrate[index] = value;
    setSections2(updatedSections);
    setInfantrate(updatedSections)
  };
  const handleAdultRateChange = (index, value) => {
    const updatedAdultrate = [...adultrate];
    updatedAdultrate[index] = value;
    setAdultrate(updatedAdultrate);
  };
  const handleHourRateChange = (index, value) => {
    const updatedHourrate = [...hourrate];
    updatedHourrate[index] = value;
    setHourrate(updatedHourrate);
  };

  const handleVehicleRateChange = (index, value) => {
    const updatedVehiclerate = [...vehiclerate];
    updatedVehiclerate[index] = value;
    setVehiclerate(updatedVehiclerate);
  };

  const handleExtraAdultRateChange = (index, value) => {
    const updatedAdultrate = [...extraAdultrate];
    updatedAdultrate[index] = value;
    setExtraAdultrate(updatedAdultrate);
  };

  const renderCommissionFields = () => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleCopyToAll = () => {
      const firstValue = adultrate[0]; // Get the value of the first field
    
      // Copy the first value to all other fields
      const updatedRates = daysOfWeek.map(() => firstValue);
    
      setAdultrate(updatedRates); // Update the state with the new values
    };
    
    
    
    
    
    return (
      <div  style={{display:'flex',marginLeft:'65px'}}>
        {daysOfWeek.map((day, index) => (
         <p>
         {/* <label>{day}</label> */}
         <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>

          <input
            key={index}
            id={`adultrate-${index}`}
            type="number"
            value={adultrate[index] || ''}
            onChange={(e) => handleAdultRateChange(index, e.target.value)}
            placeholder={day}
            style={{width:'100px',marginLeft:'15px',borderRadius:'4px',fontSize:'15px'}}
          />
            {index === 0 && (
       
           <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll}>
           <FaArrowAltCircleRight />
           </Button>
     
          )}
          
          </p>
        ))}
       
      </div>
    );
  };


  const renderCommissionFields4 = () => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleCopyToAll4 = () => {
      const firstValue = extraAdultrate[0]; // Get the value of the first field
    
      // Copy the first value to all other fields
      const updatedRates = daysOfWeek.map(() => firstValue);
    
      setExtraAdultrate(updatedRates); // Update the state with the new values
    };
    
    
    
    
    
    return (
      <div>
        {daysOfWeek.map((day, index) => (
          <>
          {/* <label>{day}</label> */}
          <input
            key={index}
            id={`extraAdultrate-${index}`}
            type="number"
            value={extraAdultrate[index] || ''}
            onChange={(e) => handleExtraAdultRateChange(index, e.target.value)}
            placeholder={day}
            style={{width:'100px',marginLeft:'15px',borderRadius:'4px',fontSize:'15px'}}
          />
            {index === 0 && (
       
           <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll4}>
           <FaArrowAltCircleRight />
           </Button>
     
          )}
          
          </>
        ))}
       
      </div>
    );
  };

  const renderCommissionFields2 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleFromAgeChange = (e) => {
      const { value } = e.target;
      const isFromAgeAlreadySelected = sections.some((section, index) => {
        return index !== sectionIndex && section.fromAge === value;
      });
      if (isFromAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setFromAgeError('From Age is already selected in another section');
      } else {
        setFromAgeError('');
        setSections((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromAge = value;
          return updatedSections;
        });
      }
    };
  
    const handleToAgeChange = (e) => {
      const { value } = e.target;
      const isToAgeAlreadySelected = sections.some((section, index) => {
        return index !== sectionIndex && section.toAge === value;
      });
      if (isToAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setToAgeError('To Age is already selected in another section');
      } else {
        setToAgeError('');
        setSections((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toAge = value;
          return updatedSections;
        });
      }
    };
 
    return (
      <div key={sectionIndex}>
      <div style={{ display: 'flex',marginLeft:'120px' }}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>From Age</Form.Label>
        <Form.Select
          style={{ width: '268px', marginLeft: '15px' }}
          required
          value={sections[sectionIndex].fromAge}
          onChange={handleFromAgeChange}
          onBlur={validateForm}
        >
          <option value="">Choose..</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
        </Form.Select>
        {/* {errors2.fromAge && <p className="text-danger" style={{ fontSize: '10px' }}>{errors2.fromAge}</p>} */}

        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>To Age</Form.Label>
        <Form.Select
          style={{ width: '268px', marginLeft: '15px' }}
          required
          value={sections[sectionIndex].toAge}
          onChange={handleToAgeChange}
          onBlur={validateForm}
          disabled={!sections[sectionIndex].fromAge}
        >
          <option value="">Choose..</option>
          {[...Array(13).keys()].slice(parseInt(sections[sectionIndex].fromAge) + 1).map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </Form.Select>
        {/* &nbsp;{errors2.toAge && <p className="text-danger" style={{ fontSize: '13px' }}>{errors2.toAge}*</p>} */}
      </div>
      <br />
      <div  style={{display:'flex',marginLeft:'71px'}}>
      {daysOfWeek.map((day, index) => (
        <div key={index} style={{ display: 'inline' }}>
             <p>
            <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>

          <input
            type="number"
            value={sections[sectionIndex].childrate[index] || ''}
            onChange={(e) => handleChildRateChange(sectionIndex, index, e.target.value)}
            placeholder={day}
            style={{ width: '100px', marginLeft: '15px', borderRadius: '4px', fontSize: '15px' }}
          />
          {index === 0 && (
            <Button variant="secondary" style={{ fontSize: '10px', borderRadius: '0px', backgroundColor:'black' }} onClick={() => handleCopyToAll2(sectionIndex, index)}>
              <FaArrowAltCircleRight />
            </Button>
          )}
           </p>
        </div>
      ))}
    </div>
    </div>
    );
  };



  const renderCommissionFields6 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  
    const handleFromDateChange2 = (e) => {
      const { value } = e.target;
    
      // Check if the selected from date overlaps with any existing section's date range
      const isFromDateOverlap = sections4.some((section, index) => {
        if (index !== sectionIndex && section.toDate3 && value <= section.toDate3) {
          return section.fromDate3 <= value && value <= section.toDate3;
        }
        return false;
      });
    
      if (isFromDateOverlap) {
        setFromDateError2('From Date overlaps with another section');
      } else {
        setFromDateError2('');
        setSections4((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromDate3 = value;
          return updatedSections;
        });
      }
      // Update promotion data
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          fromDate3: value,
        };
        return updatedPromotion;
      });
    };
    
    const handleToDateChange2 = (e) => {
      const { value } = e.target;
    
      // Check if the selected to date overlaps with any existing section's date range
      const isToDateOverlap = sections4.some((section, index) => {
        if (index !== sectionIndex && section.fromDate3 && value >= section.fromDate3) {
          return section.fromDate3 <= value && value <= section.toDate3;
        }
        return false;
      });
    
      if (isToDateOverlap) {
        setToDateError2('To Date overlaps with another section');
      } else {
        setToDateError2('');
        setSections4((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toDate3 = value;
          return updatedSections;
        });
      }

        // Update promotion data
        setPromotion((prevPromotion) => {
          const updatedPromotion = [...prevPromotion];
          updatedPromotion[sectionIndex] = {
            ...updatedPromotion[sectionIndex],
            toDate3: value,
          };
          return updatedPromotion;
        });
    };

    const handlediscounttypeChange2 = (e) => {
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          discounttype2: value,
        };
        return updatedPromotion;
      });
    };



    const handlediscountChange2 = (e) => {
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          discount2: value,
        };
        return updatedPromotion;
      });
    };


    const handleoffercodeChange = (e) => {
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          offercode: value,
        };
        return updatedPromotion;
      });
    };

    const handleremarkChange2 = (e) => {
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          promotionremark: value,
        };
        return updatedPromotion;
      });
    };
    
    return (
      <div key={sectionIndex}>
        <div style={{ display: 'flex',marginLeft:'71px' }}>
          <Form.Label style={{ marginLeft: '63px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            From Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections4[sectionIndex].fromDate3}
            onChange={handleFromDateChange2}
          />
          
  
          <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            To Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections4[sectionIndex].toDate3}
            onChange={handleToDateChange2}
            disabled={!sections4[sectionIndex].fromDate3}
            min={sections4[sectionIndex].fromDate3}
          />
          {toDateError2 && <p className="text-danger" style={{ fontSize: '10px' }}>{toDateError2}</p>}
        </div>
        <br />
        {fromDateError2 && <p className="text-danger" style={{ fontSize: '12px',fontWeight:'500',textAlign:'center' }}>{fromDateError2}</p>}
        <br />
        <div style={{display:'flex',marginLeft:'71px'}}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Discount</Form.Label>

        <Form.Select required name="discounttype2" value={sections4[sectionIndex].discounttype2} onChange={handlediscounttypeChange2}  style={{ width: '231px',height:'36px', marginLeft: '15px' }}>
                
                <option value="">Choose..</option>
                <option value="Percentage">Percentage</option>
                <option value="Fixed">Fixed</option>
              </Form.Select>


              &nbsp;
    <Form.Control  style={{ width: '231px',height:'36px' }} type="number"  name="discount2" required="true" autoComplete='off' placeholder="Enter Discount" value={sections4[sectionIndex].discount2} onChange={handlediscountChange2} />&nbsp;
    <Form.Control  style={{ width: '231px',height:'36px' }} type="text"  name="offercode" required="true" autoComplete='off' placeholder="Enter Offer Code" value={sections4[sectionIndex].offercode} onChange={handleoffercodeChange} />

&nbsp;
   
        </div>
        <br />
        <Row className="mb-3" style={{marginLeft:"0px"}}>
  <Form.Group as={Col} controlId="formGridProductdescription">
  
   <DefaultEditor rows="5" style={{backgroundColor:'white'}}   name="promotionremark" value={promotion[sectionIndex]?.promotionremark || ''} onChange={handleremarkChange2}
    />

</Form.Group>


</Row>    
        <br />
        {/* Rest of the code */}
      </div>
    );
  };




  const renderCommissionFields5 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  
    const handleFromDateChange = (e) => {
      const { value } = e.target;
  
      // Check if the selected from date overlaps with any existing section's date range
      const isFromDateOverlap = sections3.some((section, index) => {
        if (index !== sectionIndex && section.toDate2 && value <= section.toDate2) {
          return section.fromDate2 <= value && value <= section.toDate2;
        }
        return false;
      });
  
      if (isFromDateOverlap) {
        setFromDateError('From Date overlaps with another section');
      } else {
        setFromDateError('');
        setSections3((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromDate2 = value;
          return updatedSections;
        });
      }
  
      // Update seasonal data
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          fromDate2: value,
        };
        return updatedSeasonal;
      });
    };
  
    const handleToDateChange = (e) => {
      const { value } = e.target;
  
      // Check if the selected to date overlaps with any existing section's date range
      const isToDateOverlap = sections3.some((section, index) => {
        if (index !== sectionIndex && section.fromDate2 && value >= section.fromDate2) {
          return section.fromDate2 <= value && value <= section.toDate2;
        }
        return false;
      });
  
      if (isToDateOverlap) {
        setToDateError('To Date overlaps with another section');
      } else {
        setToDateError('');
        setSections3((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toDate2 = value;
          return updatedSections;
        });
      }
  
      // Update seasonal data
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          toDate2: value,
        };
        return updatedSeasonal;
      });
    };
    


    const handlediscounttypeChange = (e) => {
      const { value } = e.target;
  
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          discounttype: value,
        };
        return updatedSeasonal;
      });
    };


    const handlediscountChange = (e) => {
      const { value } = e.target;
  
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          discount: value,
        };
        return updatedSeasonal;
      });
    };


    const handleremarkChange = (e) => {
      const { value } = e.target;
  
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          seasonalremark: value,
        };
        return updatedSeasonal;
      });
    };
    
    return (
      <div key={sectionIndex}>
        <div style={{ display: 'flex',marginLeft:'71px' }}>
          <Form.Label style={{ marginLeft: '63px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            From Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections3[sectionIndex].fromDate2}
            onChange={handleFromDateChange}
          />
        
      
          
  
          <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            To Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections3[sectionIndex].toDate2}
            onChange={handleToDateChange}
            disabled={!sections3[sectionIndex].fromDate2}
            min={sections3[sectionIndex].fromDate2}
          />
          {toDateError && <p className="text-danger" style={{ fontSize: '10px' }}>{toDateError}</p>}
        </div>
        <br />
        {fromDateError && <p className="text-danger" style={{ fontSize: '12px',fontWeight:'500',textAlign:'center' }}>{fromDateError}</p>}

        <br />
        <div style={{display:'flex',marginLeft:'94px'}}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Seasonal Rate</Form.Label>

        <Form.Select required name="discounttype" value={sections3[sectionIndex].discounttype} onChange={handlediscounttypeChange}  style={{ width: '270px',height:'36px', marginLeft: '15px' }}>
                
                <option value="">Choose..</option>
                <option value="Percentage">Percentage</option>
                <option value="Fixed">Fixed</option>
              </Form.Select>


              {/* &nbsp;        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Discount</Form.Label> */}

    <Form.Control name="discount"  style={{ width: '270px',height:'36px', marginLeft: '73px'  }} type="number" value={sections3[sectionIndex].discount} onChange={handlediscountChange}    required="true" autoComplete='off' placeholder="Enter AddOn Rate"  />

&nbsp;
    
        </div>
        <br />
     
        <Row className="mb-3" style={{marginLeft:'0px'}}>
  <Form.Group as={Col} controlId="formGridProductdescription">
  {/* <Form.Label>Description</Form.Label> */}
  
   <DefaultEditor rows="5"  name="seasonalremark"  style={{backgroundColor:'white'}} value={seasonal[sectionIndex]?.seasonalremark || ''} onChange={handleremarkChange}  
    />

</Form.Group>


</Row>        <br />
       
      </div>
    );
  };
  
  
  




  const renderCommissionFields3 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleFromAgeChange2 = (e) => {
      const { value } = e.target;
      const isFromAgeAlreadySelected = sections2.some((section, index) => {
        return index !== sectionIndex && section.fromAge2 === value;
      });
      if (isFromAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setFromAgeError2('From Age is already selected in another section');
      } else {
        setFromAgeError2('');
        setSections2((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromAge2 = value;
          return updatedSections;
        });
      }
    };
  
    const handleToAgeChange2 = (e) => {
      const { value } = e.target;
      const isToAgeAlreadySelected = sections2.some((section, index) => {
        return index !== sectionIndex && section.toAge === value;
      });
      if (isToAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setToAgeError2('To Age is already selected in another section');
      } else {
        setToAgeError2('');
        setSections2((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toAge2 = value;
          return updatedSections;
        });
      }
    };
 
    return (
      <div key={sectionIndex}>
      <div style={{ display: 'flex',marginLeft:'120px' }}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>From Age</Form.Label>
        <Form.Select
          style={{ width: '268px', marginLeft: '15px' }}
          required
          value={sections2[sectionIndex].fromAge2}
          onChange={handleFromAgeChange2}
          onBlur={validateForm2}
        >
          <option value="">Choose..</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          
        </Form.Select>
        {/* {errors2.fromAge && <p className="text-danger" style={{ fontSize: '10px' }}>{errors2.fromAge}</p>} */}

        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>To Age</Form.Label>
        <Form.Select
          style={{ width: '268px', marginLeft: '15px' }}
          required
          value={sections2[sectionIndex].toAge2}
          onChange={handleToAgeChange2}
          onBlur={validateForm2}
          disabled={!sections2[sectionIndex].fromAge2}
        >
          <option value="">Choose..</option>
          {[...Array(7).keys()].slice(parseInt(sections2[sectionIndex].fromAge2) + 1).map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </Form.Select>
        {/* &nbsp;{errors2.toAge && <p className="text-danger" style={{ fontSize: '13px' }}>{errors2.toAge}*</p>} */}
      </div>
      <br />
      <div  style={{display:'flex',marginLeft:'71px'}}>
      {daysOfWeek.map((day, index) => (
        <div key={index} style={{ display: 'inline' }}>
           <p>
            <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>

          <input
            type="number"
            value={sections2[sectionIndex].infantrate[index] || ''}
            onChange={(e) => handleInfantRateChange(sectionIndex, index, e.target.value)}
            placeholder={day}
            style={{ width: '100px', marginLeft: '15px', borderRadius: '4px', fontSize: '15px' }}
          />
          {index === 0 && (
            <Button variant="secondary" style={{ fontSize: '10px', borderRadius: '0px', backgroundColor:'black' }} onClick={() => handleCopyToAll3(sectionIndex, index)}>
              <FaArrowAltCircleRight />
            </Button>
          )}
          </p>
        </div>
      ))}
    </div>
    </div>
    );
  };

  
  const validateToDate = (toDate) => {
    if (!fromDate) {
      return 'Please select a From Date first';
    }
  
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
  
    if (toDateObj < fromDateObj) {
      return 'To Date must be later than or equal to From Date';
    }
  
    if (dateRangeExists) {
      return false; // Return false if the date range already exists
    }
  
    return true; // Return true if the validation passes
  };
  

  const validateToDate2 = (stoDate) => {
    if (!sfromDate) {
      return 'Please select a From Date first';
    }
  
    const fromDateObj = new Date(sfromDate);
    const toDateObj = new Date(stoDate);
  
    if (toDateObj < fromDateObj) {
      return 'To Date must be later than or equal to From Date';
    }
  
    return true; // Return true if the validation passes
  };

  const validateForm = () => {
    const newErrors = {};

    if (fromAge === '') {
      newErrors.fromAge = 'From Age is required';
    }

    if (toAge === '') {
      newErrors.toAge = 'To Age is required';
    } else if (parseInt(toAge) <= parseInt(fromAge)) {
      newErrors.toAge = 'To Age must be greater than From Age';
    }

    setErrors2(newErrors);
  };

  const validateForm2 = () => {
    const newErrors = {};

    if (fromAge2 === '') {
      newErrors.fromAge2 = 'From Age is required';
    }

    if (toAge2 === '') {
      newErrors.toAge2 = 'To Age is required';
    } else if (parseInt(toAge2) <= parseInt(fromAge2)) {
      newErrors.toAge2 = 'To Age must be greater than From Age';
    }

    setErrors3(newErrors);
  };

  
  const renderCommissionFieldsHourly = () => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleCopyToAll = () => {
      const firstValue = hourrate[0]; // Get the value of the first field
    
      // Copy the first value to all other fields
      const updatedRates = daysOfWeek.map(() => firstValue);
    
      setHourrate(updatedRates); // Update the state with the new values
    };
    
    
    
    
    
    return (
      <div  style={{display:'flex',marginLeft:'65px'}}>
        {daysOfWeek.map((day, index) => (
          <p>
          {/* <label>{day}</label> */}
          <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>
          <input
            key={index}
            id={`hourrate-${index}`}
            type="number"
            value={hourrate[index] || ''}
            onChange={(e) => handleHourRateChange(index, e.target.value)}
            placeholder={day}
            style={{width:'100px',marginLeft:'15px',borderRadius:'4px',fontSize:'15px'}}
          />
            {index === 0 && (
       
           <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll}>
           <FaArrowAltCircleRight />
           </Button>
     
          )}
          
          </p>
        ))}
       
      </div>
    );
  };



  const renderCommissionFieldsVehicle = () => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleCopyToAll = () => {
      const firstValue = vehiclerate[0]; // Get the value of the first field
    
      // Copy the first value to all other fields
      const updatedRates = daysOfWeek.map(() => firstValue);
    
      setVehiclerate(updatedRates); // Update the state with the new values
    };
    
    
    
    
    
    return (
      <div  style={{display:'flex',marginLeft:'65px'}}>
        {daysOfWeek.map((day, index) => (
          <p>
          {/* <label>{day}</label> */}
          <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>
          <input
            key={index}
            id={`vehiclerate-${index}`}
            type="number"
            value={vehiclerate[index] || ''}
            onChange={(e) => handleVehicleRateChange(index, e.target.value)}
            placeholder={day}
            style={{width:'100px',marginLeft:'15px',borderRadius:'4px',fontSize:'15px'}}
          />
            {index === 0 && (
       
           <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll}>
           <FaArrowAltCircleRight />
           </Button>
     
          )}
          
          </p>
        ))}
       
      </div>
    );
  };



  

  const handleFromAgeChange2 = (e) => {
    setFromAge2(e.target.value);
    setToAge2('');
  };
  
const handlePaxlimit = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name == "paxlimit" && checked){
    setPaxlimit(1);
    setPaxlimitShow(true)
  }else {
    setPaxlimit(0)
    setPaxlimitShow(false);
  }
}
  const handleCommission = (e) =>{

    if(e == "Percentage"){
      setPerShow(true);
      setFixamtShow(false)
    }else if(e == "Fixamt"){
      setFixamtShow(true)
      setPerShow(false);
    }
    }
  
  useEffect(() => {
    dispatch(getAllProduct());
    dispatch(getSingleProductRate(SubProductId));
    dispatch(getSinglePaxhealth(pid));
    dispatch(getAllMainSubProduct());
    const filterperm = subproducts2.filter(obj => obj.id == SubProductId)
    setPermdata(filterperm[0]);

    
    
  }, []);
  const handleOnSubmit = (e) => {
    e.preventDefault();
    if(productid && subproductname && status){
        const newSubProductCreation1 = {
            productid,
            subproductname,
            paxlimit,
            paxlimitno,
            status,

        };
        dispatch(
            newSubProductCreation(newSubProductCreation1)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Sub Product Details Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
  
          // navigate('/subproductList');
         
            setTabHandle2('rate')
        
        setProductid('');
        setSubproductname('');
        setPaxlimitNo('');
        setStatus('');
        e.target.reset();
    }
 
  };


  const handleOnSubmit1 = (e) => {
    e.preventDefault();

        const newAdultRateCreation = {
            SubProductId,
            fromDate,
            toDate,
            adultrate,

        };
        dispatch(
            newAdultRatesCreation(newAdultRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Details Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
 
 
  };



  const handleOnSubmithour = (e) => {
    e.preventDefault();

        const newHourRateCreation = {
            SubProductId,
            fromDate,
            toDate,
            hourrate,

        };
        dispatch(
            newHourRatesCreation(newHourRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Details Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
 
 
  };


  const handleOnSubmitvehicle = (e) => {
    e.preventDefault();

        const newVehicleRateCreation = {
            SubProductId,
            fromDate,
            toDate,
            vehiclerate,

        };
        dispatch(
            newVehicleRatesCreation(newVehicleRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Details Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
 
 
  };


  
  const handleOnSubmit2 = (e) => {
    e.preventDefault();
      if(sections.length > 0){
        const newChildRateCreation = {
            baseid,
            fromDate,
            toDate,
            fromAge,
            toAge,
            childRates: childrate,

        };
        dispatch(
            newChildRatesCreation(newChildRateCreation)
        )
        setTabHandle('infantrate');

        Swal.fire({
            title: 'Success!',
            text: 'Child Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
        }else{
          Swal.fire({
            title: 'Are you sure want to skip the section?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
              
              setTabHandle('infantrate');
                  Swal.fire('You have Skipped the Section!', '', 'success');
           
            }
        
             else if (result.isDenied) {
              Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
            }
          })

        }
 
 
  };


    
  const handleOnSubmit3 = (e) => {
    e.preventDefault();
    if(sections2.length > 0){

 

        const newInfantRateCreation = {
            baseid,
            fromDate,
            toDate,
            fromAge2,
            toAge2,
            infantRates: infantrate,

        };
        dispatch(
            newInfantRatesCreation(newInfantRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Infant Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
          setTabHandle('seasonalrate')

        }else{
          Swal.fire({
            title: 'Are you sure want to skip the section?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
              
              setTabHandle('seasonalrate')
                  Swal.fire('You have Skipped the Section!', '', 'success');
           
            }
        
             else if (result.isDenied) {
              Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
            }
          })

        }

 
 
  };

  const handleOnSubmit4 = (e) => {
    e.preventDefault();

    if(sections3.length > 0){

        const newSeasonalRateCreation = {
            baseid,
           
            seasonalRates: seasonal,

        };
        dispatch(
          newSeasonalRatesCreation(newSeasonalRateCreation)
        )
        setTabHandle('promotionalrate')

        Swal.fire({
            title: 'Success!',
            text: 'Seasonal Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })


    }else{

      Swal.fire({
        title: 'Are you sure want to skip the section?',
        showDenyButton: true,
        icon:'error',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        }
      }).then((result) => {
        if (result.isConfirmed) {
          
          setTabHandle('promotionalrate')
              Swal.fire('You have Skipped the Section!', '', 'success');
       
        }
    
         else if (result.isDenied) {
          Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
        }
      })


    }
 
 
  };
  const onBack = () => {
   
   //console.log('select role '+id);
   navigate('/SubproductListId/' + pid + "/" +pname); 
}



  const handleOnSubmit5 = (e) => {
    e.preventDefault();
    if(sections4.length > 0){


        const newPromotionRateCreation = {
            baseid,
           
            promotionRates: promotion,

        };
        dispatch(
          newPromotionRatesCreation(newPromotionRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Promotion Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
           navigate('/subproductList');

        }else{
          Swal.fire({
            title: 'Are you sure want to skip the section?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
              
              navigate('/subproductList');
              Swal.fire('You have Skipped the Section!', '', 'success');
           
            }
        
             else if (result.isDenied) {
              Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
            }
          })


        }
 
 
  };
  const onDateChange = () => {
    // console.log("dateRangeExists",dateRangeExists)
    // if(dateRangeExists == true){
    //   setToDate('');
    // }
  }

  const canSave = Boolean (productid) && Boolean(subproductname) && Boolean(status)
//console.log(curstatus);
//console.log('msg');
//console.log(curmessage);
  //console.log(passwordError.confirmPassword);
  
  return (
    <>
          <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman', fontWeight:'600' }}>Add Additonal Rates</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <div><span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white',cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div>
   
                        </Row>
                        <br />
                <Tabs
      // defaultActiveKey='basic'
      activeKey={tabHandle2}
      id="justify-tab-example"
      className="mb-3"
      justify
    >
     

           
    <Tab eventKey="rate" title="Rate Details">
      
    
    {/* <span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white' ,cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span><center><span className="badge bg" style={{backgroundColor:'rgb(156 186 237)',color:'black'}}>Sub Product Name: {name}</span></center> */}
      
      <hr />
      
    <Tabs
      // defaultActiveKey='adultrate'
      activeKey={tabHandle}
      id="justify-tab-example"
      className="mb-3"
      justify
      
    >
      
      {permdata?.isithourly == 1 ?  
                    <Tab eventKey="adultrate" title="Hourly Rates">



                      <Form className=" mx-4 my-2" component="form" noValidate autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmithour(e))}> {/* handleOnSubmit() */}

                        <Card style={{ backgroundColor: '#1c355ea3', width: '100%' }}>
                          <Row className="mb-3" style={{ padding: '10px' }}>
                            <Form.Group as={Col} controlId="formGridServiceType">
                              <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
                              <Form.Control
                                type="date"
                                name="fromDate"
                                required
                                min={new Date().toISOString().split('T')[0]}

                                autoComplete="off"
                                placeholder="Enter From Date"
                                {...register('fromDate', { required: true })}
                                onChange={(e) => { setFromDate(e.target.value); setToDate(''); }}
                              />
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridMobile">
                              <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
                              <Form.Control
                                type="date"
                                name="toDate"
                                required
                                value={toDate}
                                autoComplete="off"
                                placeholder="Enter To Date"
                                {...register('toDate', { required: true, validate: validateToDate })}
                                min={fromDate}
                                disabled={!fromDate}
                                onChange={(e) => setToDate(e.target.value)}
                              />
                              {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
                            </Form.Group>
                          </Row>

                          <h6 style={{ textAlign: 'center', marginTop: '10px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Hourly Rates</h6>

                          <hr style={{ marginTop: '5px', color: 'white' }} />


                          {renderCommissionFieldsHourly()}
                          <br />
                          {/* <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

                          <br />
                          <div><Button variant="" type='submit' disabled={fromDate && toDate ? 0 : 1} onClick={() => setTabHandle('seasonalrate')} style={{ width: '100px', float: 'right', backgroundColor: '#1c355e', color: 'white', marginRight: '5px', fontSize: '10px' }}><FaArrowAltCircleRight />&nbsp;Next </Button></div>
                          <br />

                        </Card> </Form>




                    </Tab>:''}


                    {permdata?.isitvehicle == 1 ?  
                    <Tab eventKey="adultrate" title="Vehicle Rates">



                      <Form className=" mx-4 my-2" component="form" noValidate autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmitvehicle(e))}> {/* handleOnSubmit() */}

                        <Card style={{ backgroundColor: '#1c355ea3', width: '100%' }}>
                          <Row className="mb-3" style={{ padding: '10px' }}>
                            <Form.Group as={Col} controlId="formGridServiceType">
                              <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
                              <Form.Control
                                type="date"
                                name="fromDate"
                                required
                                min={new Date().toISOString().split('T')[0]}

                                autoComplete="off"
                                placeholder="Enter From Date"
                                {...register('fromDate', { required: true })}
                                onChange={(e) => { setFromDate(e.target.value); setToDate(''); }}
                              />
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridMobile">
                              <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
                              <Form.Control
                                type="date"
                                name="toDate"
                                required
                                value={toDate}
                                autoComplete="off"
                                placeholder="Enter To Date"
                                {...register('toDate', { required: true, validate: validateToDate })}
                                min={fromDate}
                                disabled={!fromDate}
                                onChange={(e) => setToDate(e.target.value)}
                              />
                              {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
                            </Form.Group>
                          </Row>

                          <h6 style={{ textAlign: 'center', marginTop: '10px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Vehiclely Rates</h6>

                          <hr style={{ marginTop: '5px', color: 'white' }} />


                          {renderCommissionFieldsVehicle()}
                          <br />
                          {/* <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

                          <br />
                          <div><Button variant="" type='submit' disabled={fromDate && toDate ? 0 : 1} onClick={() => setTabHandle('seasonalrate')} style={{ width: '100px', float: 'right', backgroundColor: '#1c355e', color: 'white', marginRight: '5px', fontSize: '10px' }}><FaArrowAltCircleRight />&nbsp;Next </Button></div>
                          <br />

                        </Card> </Form>




                    </Tab>:''}
            {permdata?.isithourly !== 1 && permdata?.isitvehicle !== 1 ?
            <Tab eventKey="adultrate" title="Adult Rates">
    

            <Form className=" mx-4 my-2" component="form"    autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit1(e))}> {/* handleOnSubmit() */}
              {permdata?.adult_per == 1 || pxData?.adult_permission == 0 ? <>     <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
            <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
          autoComplete="off"
          min={new Date().toISOString().split('T')[0]}
          placeholder="Enter From Date"
          {...register('fromDate', { required: true })}
          onChange={(e) => {setFromDate(e.target.value);setDatedisable(false);setToDate('');}}
        />
      </Form.Group>


      <Form.Group as={Col} controlId="formGridMobile">
  <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
  <Form.Control
    type="date"
    name="toDate"
    required
    autoComplete="off"
    placeholder="Enter To Date"
    value={toDate}
    min={fromDate}
    disabled={datedisable}
    onChange={(e) => {
      setToDate(e.target.value);
      setIsToDateSelected(true);
      onDateChange()
    }}
  />
  
  {isToDateSelected && dateRangeExists && (
    <p className='' style={{color:'red'}}>Selected date range already exists</p>
  )}
</Form.Group>



    </Row>

    
     <div><Button variant="" type='submit' disabled={fromDate && toDate ? 0 : 1}   onClick={()=>setTabHandle('childrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
     <br />

    </Card>
    <p style={{textAlign:'center',color:'red'}}><FaBan />&nbsp;Adults Are Not Permitted.</p>


</>:<>
            <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
            <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
          autoComplete="off"
          min={new Date().toISOString().split('T')[0]}
          placeholder="Enter From Date"
          {...register('fromDate', { required: true })}
          onChange={(e) => {setFromDate(e.target.value);setDatedisable(false);setToDate('');}}
        />
      </Form.Group>


      <Form.Group as={Col} controlId="formGridMobile">
  <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
  <Form.Control
    type="date"
    name="toDate"
    required
    autoComplete="off"
    placeholder="Enter To Date"
    value={toDate}
    min={fromDate}
    disabled={datedisable}
    onChange={(e) => {
      setToDate(e.target.value);
      setIsToDateSelected(true);
      onDateChange()
    }}
  />
  {isToDateSelected && dateRangeExists && (
    <p className='' style={{color:'red'}}>Selected date range already exists</p>
  )}
</Form.Group>



    </Row>

    <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Adult Rates</h6>
      
      <hr style={{marginTop:'5px',color:'white'}} />
     

      {renderCommissionFields()}
    <br />
      {/* <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

     <br />
     <div><Button variant="" type='submit' disabled={fromDate && toDate ? 0 : 1}   onClick={()=>setTabHandle('childrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
     <br />

    </Card></>}

   

          </Form>
    </Tab>
    :''}


 {permdata?.isithourly !== 1 && permdata?.isitvehicle !== 1 ?
    <Tab eventKey="childrate" title="Child Rates">
    

    <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit2(e))}> {/* handleOnSubmit() */}
{permdata?.child_per == 1 || pxData?.child_permission == 0 ? <> <Card  style={{backgroundColor:''}}>
              <br />
              <p style={{textAlign:'center',color:'red'}}><FaBan />&nbsp;Childs Are Not Permitted.</p>
              
              
            <br />
     <div><Button variant=""  onClick={()=>setTabHandle('infantrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
     <br />
              </Card></>: <> <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
    <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Child Rates</h6>
      
 
    <div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection}><FaPlus/>&nbsp;Add </Button></div>
{sections.map((section, index) => (
        <div key={index}>
         <hr style={{marginTop:'5px',color:'white'}} />
          {/* Render your section-specific fields here */}
          {renderCommissionFields2(index)}
          <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection(index)}><FaTrash  /></Button>
        </div>
      ))}
      <br />
      <hr style={{marginTop:'5px',color:'white'}} />

      

      <br />
      {/* <div><Button variant=""  type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

     <br />
     {/* onClick={()=>setTabHandle('infantrate')} */}
     
     <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
     <br />

    </Card></>}
   
  </Form>
</Tab>
:''}
{permdata?.isithourly !== 1 && permdata?.isitvehicle !== 1 ?

<Tab eventKey="infantrate" title="Infant Rates">
    

    <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit3(e))}> {/* handleOnSubmit() */}
{permdata?.infant_per == 1 || pxData?.infant_permission == 0 ? <> <Card  style={{backgroundColor:''}}>
              <br />
              <p style={{textAlign:'center',color:'red'}}><FaBan />&nbsp;Infants Are Not Permitted.</p>
              
              
            <br />
            {/* onClick={()=>setTabHandle('seasonalrate')} */}
     <div><Button variant="" onClick={()=>setTabHandle('seasonalrate')}   style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
     <br />
              </Card></>:<>  <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
    <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Infant Rates</h6>
    <div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection2}><FaPlus/>&nbsp;Add </Button></div>



     

{sections2.map((section, index) => (
        <div key={index}>
                <hr style={{marginTop:'5px',color:'white'}} />
 
          {/* Render your section-specific fields here */}
          {renderCommissionFields3(index)}
          <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection2(index)}><FaTrash  /></Button>
        </div>
      ))}
      <br />
      <hr style={{marginTop:'5px',color:'white'}} />
      

      <br />
      {/* <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

     <br />
     
     <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
     <br />
    </Card></>}
  
  </Form>



</Tab>
:''}
<Tab eventKey="seasonalrate" title="Seasonal Supplementary">
    
<Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit4(e))}> {/* handleOnSubmit() */}

<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Seasonal Supplementary</h6>
<div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection3}><FaPlus/>&nbsp;Add </Button></div>



 

{sections3.map((section, index) => (
    <div key={index}>
            <hr style={{marginTop:'5px',color:'white'}} />

      {/* Render your section-specific fields here */}
      {renderCommissionFields5(index)}
      <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection3(index)}><FaTrash  /></Button>
    </div>
  ))}
  <br />
  <hr style={{marginTop:'5px',color:'white'}} />
  
  <br />
      {/* <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}


 <br />
 
 <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
 <br />
</Card>
</Form>
</Tab>

<Tab eventKey="promotionalrate" title="Promotion Discount">
    

<Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit5(e))}> {/* handleOnSubmit() */}

<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Promotion Discount</h6>
<div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection4}><FaPlus/>&nbsp;Add </Button></div>



 

{sections4.map((section, index) => (
    <div key={index}>
            <hr style={{marginTop:'5px',color:'white'}} />

      {/* Render your section-specific fields here */}
      {renderCommissionFields6(index)}
      <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection4(index)}><FaTrash  /></Button>
    </div>
  ))}
  <br />
  <hr style={{marginTop:'5px',color:'white'}} />
  

  <br />
      {/* <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

 <br />
 
 <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
 <br />
</Card>
</Form>
</Tab>

           
   

    </Tabs>

    

</Tab>


    </Tabs>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreateSubProduct;